angular.module('PinMeTo.directives').directive('pmtFormErrors', [
	function () {
		'use strict';

		return {
			restrict: 'A',
			replace: true,
			scope: { formObject: '=pmtFormErrors' },
			link: function (/*scope, element, attrs*/) {},
			templateUrl: 'pmtShared/directives/pmtFormErrors.html'
		};
	}
]);
